import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import OurValues from "./pages/OurValues";
import Leadership from "./pages/Leadership";
import LeadershipProfile from "./pages/LeadershipProfile";
import ProductsServices from "./pages/ProductsServices";
import Investor from "./pages/Investor";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Innovation from "./pages/values/Innovation";
import Integrity from "./pages/values/Integrity";
import Collaboration from "./pages/values/Collaboration";
import Impact from "./pages/values/Impact";
import Compassion from "./pages/values/Compassion";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTest from "./pages/AdminTest";

// Service Pages
import WebDevelopment from "./pages/services/WebDevelopment";
import AppDevelopment from "./pages/services/AppDevelopment";
import ITConsulting from "./pages/services/ITConsulting";

// Product Pages
import GoFella from "./pages/products/GoFella";

// Investor Pages
import InvestmentOverview from "./pages/investor/Overview";

// Career Pages
import UIDesigner from "./pages/careers/UIDesigner";
import WebDeveloperCareer from "./pages/careers/WebDeveloper";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout wrapper component to conditionally show Header/Footer
function Layout({ children }) {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminPage && <Header />}
      <main className="min-h-screen">
        {children}
      </main>
      {!isAdminPage && <Footer />}
    </>
  );
}

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Layout>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
            <Route path="/admin-test" element={<AdminTest />} />
            
            {/* Service Detail Routes */}
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/app-development" element={<AppDevelopment />} />
            <Route path="/services/it-consulting" element={<ITConsulting />} />
            
            {/* Product Detail Routes */}
            <Route path="/products/gofella" element={<GoFella />} />
            
            {/* Investor Routes */}
            <Route path="/investor/overview" element={<InvestmentOverview />} />
            
            {/* Career Detail Routes */}
            <Route path="/careers/ui-designer" element={<UIDesigner />} />
            <Route path="/careers/web-developer" element={<WebDeveloperCareer />} />
            
            {/* Main Website Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/values" element={<OurValues />} />
            <Route path="/about/leadership" element={<Leadership />} />
            <Route path="/about/leadership/:leaderId" element={<LeadershipProfile />} />
            <Route path="/products-services" element={<ProductsServices />} />
            <Route path="/investor" element={<Investor />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:articleId" element={<NewsArticle />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/values/innovation" element={<Innovation />} />
            <Route path="/values/integrity" element={<Integrity />} />
            <Route path="/values/collaboration" element={<Collaboration />} />
            <Route path="/values/impact" element={<Impact />} />
            <Route path="/values/compassion" element={<Compassion />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;